import React from 'react';
import { useChat } from './hooks/useChat';
import { ChatProvider } from '../../context/ChatContext';
import { TranslationProvider } from '../../context/TranslationContext';
/**
 *
 * Chat - Wrapper component for Chat. The needs to be placed around any other Chat components.
 * This component provides the ChatContext to all other components.
 *
 * ChatContext provides the following values:
 *
 * - channel - the current active channel
 * - client - the client connection
 * - closeMobileNav - function to close mobile navigation
 * - mutes - array of muted users
 * - navOpen - boolean if navigation is open
 * - openMobileNav - function to open mobile navigation
 * - setActiveChannel - a function to set currently active channel
 * - theme - current theme
 *
 * It also exposes the [withChatContext](https://getstream.github.io/stream-chat-react/#section-withchatcontext) HOC which you can use to consume the [ChatContext](https://getstream.github.io/stream-chat-react/#section-chatcontext).
 * @example ./Chat.md
 */
export var Chat = function (props) {
    var children = props.children, client = props.client, i18nInstance = props.i18nInstance, _a = props.initialNavOpen, initialNavOpen = _a === void 0 ? true : _a, _b = props.theme, theme = _b === void 0 ? 'messaging light' : _b, _c = props.useImageFlagEmojisOnWindows, useImageFlagEmojisOnWindows = _c === void 0 ? false : _c;
    var _d = useChat({ client: client, i18nInstance: i18nInstance, initialNavOpen: initialNavOpen }), channel = _d.channel, closeMobileNav = _d.closeMobileNav, mutes = _d.mutes, navOpen = _d.navOpen, openMobileNav = _d.openMobileNav, setActiveChannel = _d.setActiveChannel, translators = _d.translators;
    if (!translators.t)
        return null;
    return (React.createElement(ChatProvider, { value: {
            channel: channel,
            client: client,
            closeMobileNav: closeMobileNav,
            mutes: mutes,
            navOpen: navOpen,
            openMobileNav: openMobileNav,
            setActiveChannel: setActiveChannel,
            theme: theme,
            useImageFlagEmojisOnWindows: useImageFlagEmojisOnWindows,
        } },
        React.createElement(TranslationProvider, { value: translators }, children)));
};
